<template>
  <div>
    <b-container id="nomalInfoContainer">
      <b-row>
        <b-col>
          <b-form @submit="onSubmit" @reset="onReset">
            <b-form-group id="input-group-1" label-for="input-1">
              <b-form-input
                id="input-1"
                v-model="form.email"
                type="email"
                required
                placeholder="請輸入信箱"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-2" label-for="input-2">
              <b-form-input
                id="input-2"
                v-model="form.cellPhone"
                type="number"
                required
                placeholder="請輸入手機"
              ></b-form-input>
            </b-form-group>
            <b-form-group>
              <b-container fluid>
                <b-row>
                  <b-col cols="6" style="padding-left: 0px;">
                    <b-button type="submit" variant="danger" block>下一步</b-button>
                  </b-col>
                  <b-col cols="6" style="padding-right: 0px;">
                    <b-button type="reset" variant="danger" block>清空</b-button>
                  </b-col>
                </b-row>
              </b-container>
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { LeadHandler } from "@/handler/LeadHandler.js";
import { Loading } from "element-ui";
import store from "@/vuex/store_lead.js";

export default {
  props: ["tutorChatToken"],
  data() {
    return {
      checkReasult: [],
      form: {
        email: "",
        cellPhone: ""
      }
    };
  },
  created() {
    this.form.email = store.state.bindInfo.email;
    this.form.cellPhone = store.state.bindInfo.cellPhone;
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      let myreg = /^09\d{2}-?\d{3}-?\d{3}$/;
      if (this.form.cellPhone && myreg.test(this.form.cellPhone)) {
        store.dispatch("saveCheckLeadInfo", this.form);
        var obj = {};
        obj.form = this.form;
        obj.tct = this.tutorChatToken;
        store.dispatch("checkLead", obj);
      } else {
        alert("手機號格式不正確");
      }
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.cellPhone = "";
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>

<style scoped>
#nomalInfoContainer {
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  font-size: 13px;
  padding: 15px 15px 0;
}
.form-control {
  border-color: #e8e8e8;
  font-size: 15px;
  padding: 10px;
}
.form-control:focus {
  box-shadow: none;
}
.btn {
  float: right;
  font-size: 13px;
  background: #b20404;
}
.form-group {
  margin-bottom: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/CreateLead_Check.vue